// Lets the Inspector open a field tool for the selected wall or room. The Field
// tools menu owns those dialogs and registers itself here while it is mounted.
let handler = null;
export function setFieldToolHandler(next) { handler = next; return () => { if (handler === next) handler = null; }; }
export const fieldToolsAvailable = () => !!handler;
export function openFieldTool(tool) { handler?.(tool); }
